import { createClient } from 'contentful';
import { CONTENTFUL_SPACE, CONTENTFUL_ACCESS_TOKEN } from '@/constants/env';
interface ImageContent {
  fields: { file: { url: string }; title?: string; description?: string };
}
interface HomeCmsResponse {
  id: string;
  title?: string;
  subtitle?: string;
  shortContentOne?: string;
  shortContentTwo?: string;
  shortContentThree?: string;
  shortContentFour?: string;
  longContentOne?: string;
  longContentTwo?: string;
  longContentThree?: string;
  longContentFour?: string;
  longContentFive?: string;
  longContentSix?: string;
  longContentSeven?: string;
  longContentEight?: string;
  longContentNine?: string;
  longContentTen?: string;
  featureImage?: ImageContent;
  gallery?: ImageContent[];
  buttonOneLabel?: string;
}

interface Image {
  title?: string;
  description?: string;
  url?: string;
}

export interface HomeCms {
  title?: string;
  subtitle?: string;
  shortContentOne?: string;
  shortContentTwo?: string;
  shortContentThree?: string;
  shortContentFour?: string;
  markdownContent?: string[];
  featureImage?: Image;
  gallery?: Image[];
  buttonOneLabel?: string;
}

interface PlansCmsResponse {
  id: string;
  title?: string;
  subtitle?: string;
  longContentOne?: string;
  longContentTwo?: string;
  longContentThree?: string;
  longContentFour?: string;
}

export interface PlansCms {
  id: string;
  title?: string;
  subtitle?: string;
  markdownContent: string[];
}
export const getDefaultHomeCms = (): HomeCms => ({
  title: '',
  subtitle: '',
  shortContentOne: '',
  shortContentTwo: '',
  shortContentThree: '',
  shortContentFour: '',
  markdownContent: [],
  featureImage: { title: '', description: '', url: '' },
  gallery: [],
  buttonOneLabel: '',
});

export const getDefaultPlansCms = (): PlansCms => ({
  id: '',
  title: '',
  subtitle: '',
  markdownContent: [],
});
const client = createClient({
  space: CONTENTFUL_SPACE,
  accessToken: CONTENTFUL_ACCESS_TOKEN,
});

export const getPlansContent = async (): Promise<void | PlansCms> => {
  if (!client) return;
  const response = client
    .getEntries<PlansCmsResponse>({
      content_type: 'plans',
    })
    .then((entries) => {
      return entries.items.map((entry) => {
        const fields = entry.fields;
        const markdownContent = [
          fields.longContentOne || '',
          fields.longContentTwo || '',
          fields.longContentThree || '',
        ];
        return {
          id: fields.id,
          title: fields.title,
          subtitle: fields.subtitle,
          markdownContent,
        };
      })[0];
    })
    .catch((err) => {
      console.error('CMS', err);
    });
  return response;
};

export const getReviewsCms = async (): Promise<void | HomeCms> => {
  if (!client) return;
  const response = client
    .getEntry<HomeCmsResponse>('593Mje0oDJwuTOy6nk88y2')
    .then((entry) => {
      const fields = entry.fields;

      const markdownContent = [
        fields.longContentOne || '',
        fields.longContentTwo || '',
        fields.longContentThree || '',
        fields.longContentFour || '',
        fields.longContentFive || '',
        fields.longContentSix || '',
        fields.longContentSeven || '',
        fields.longContentEight || '',
        fields.longContentNine || '',
        fields.longContentTen || '',
      ];
      return { markdownContent };
    })
    .catch((err) => {
      console.error('CMS', err);
    });
  return response;
};

export const getFeaturedOnCms = async (): Promise<void | HomeCms> => {
  if (!client) return;
  const response = client
    .getEntry<HomeCmsResponse>('3FdtRuCNCC5yAozEzCdprx')
    .then((entry) => {
      const fields = entry.fields;
      const gallery = fields.gallery?.map((image) => ({
        url: image.fields.file.url || '',
        title: image.fields.title || '',
        description: image.fields.description || '',
      }));
      return { title: fields.title, gallery };
    })
    .catch((err) => {
      console.error('CMS', err);
    });
  return response;
};
